import Link from '@components/common/Link/Link'
import Media from '@components/ui/Media/Media'

import { formatPriceV2 } from '@lib/format-price'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import { generateMediaUrlV2 } from '@lib/utils'
import { selectAlpha2Code } from '@redux/globalSlice'
import { mapEdgesToItems } from '@utils/map'
import clsx from 'clsx'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import s from './PointCard.module.scss'
import { ShopTheLookPoint } from './PointDimensions'
interface PointCardProps {
  point: ShopTheLookPoint
}
const PointCard: FC<PointCardProps> = ({ point }) => {
  const alpha2Code = useSelector(selectAlpha2Code)
  const product = point.product
  return (
    <Link
      link={{
        url: `/products/${product.slug}`,
      }}
      query={{ itemNumber: product.heroVariant.sku }}
      className={s.imageLink}
    >
      <div className={clsx(s.container)}>
        <Media
          mediaWithCrops={
            {
              url: generateMediaUrlV2(
                mapEdgesToItems(point.product.heroVariant.media).find((x) => x)
                  ?.src,
              ),
              media: {
                __typename: 'Image',
                url: generateMediaUrlV2(
                  mapEdgesToItems(point.product.heroVariant.media).find(
                    (x) => x,
                  )?.src,
                ),
              },
            } as MediaWithCropsFragment
          }
          className={clsx(s.media, {})}
          mediaClassName={s.mediaImage}
          disableShopTheLook
        />

        <div className={s.information}>
          <span className={s.name}>{product.name}</span>
          <span className={s.attributes}>
            {product.heroVariant.selectedAttributes?.find(Boolean).value}
          </span>
          <span className={s.price}>
            {formatPriceV2(alpha2Code, product.heroVariant.price.value)}
          </span>
        </div>
      </div>
    </Link>
  )
}

export default PointCard
